import React from 'react';
import { Hero2Text, Paragraph1 } from '../texts/Texts';

export default function PricingPageHeaderComponent() {
  return (
    <div className="mx-auto flex flex-col items-center space-y-4 text-center">
      <Hero2Text className="text-product2-content-primary">
        Kickstart your coding career
      </Hero2Text>
      <Paragraph1 className="max-w-[600px] text-product2-content-secondary">
        Learn in-demand coding skills and create a portfolio of projects that
        attracts employers and clients
      </Paragraph1>
    </div>
  );
}
